export function MinusIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_205_2726)'>
        <path
          d='M0.75 6.75H11.25C11.4489 6.75 11.6397 6.67098 11.7803 6.53033C11.921 6.38968 12 6.19891 12 6C12 5.80109 11.921 5.61032 11.7803 5.46967C11.6397 5.32902 11.4489 5.25 11.25 5.25H0.75C0.551088 5.25 0.360322 5.32902 0.21967 5.46967C0.0790176 5.61032 0 5.80109 0 6C0 6.19891 0.0790176 6.38968 0.21967 6.53033C0.360322 6.67098 0.551088 6.75 0.75 6.75Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_205_2726'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}

export function PlusIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_205_2686)'>
        <g clipPath='url(#clip1_205_2686)'>
          <path
            d='M6 0C6.41416 8.86845e-06 6.74999 0.335804 6.75 0.75V5.25H11.25C11.6642 5.25005 12 5.5858 12 6C12 6.4142 11.6642 6.74998 11.25 6.75H6.75V11.25C6.75 11.6642 6.41417 11.9999 6 12C5.58583 12 5.25003 11.6642 5.25 11.25V6.75H0.75C0.335831 6.75 2.98827e-05 6.4142 0 6C1.18622e-05 5.58578 0.335779 5.25 0.75 5.25H5.25V0.75C5.25001 0.33578 5.58578 -2.5076e-07 6 0Z'
            fill='currentColor'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_205_2686'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_205_2686'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}
